import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
    return (
        <div className="w-full">
            <section className="bg-slate-950 px-6 py-20 text-white sm:px-10 sm:py-24 lg:px-12">
                <div className="mx-auto max-w-7xl">
                    <p className="text-sm font-semibold uppercase tracking-widest text-orange-400">About BhuWaivs</p>
                    <h1 className="mt-4 max-w-4xl font-serif text-4xl font-bold leading-tight text-white sm:text-6xl">
                        Making ground motion easier to understand.
                    </h1>
                    <p className="mt-6 max-w-3xl text-lg leading-relaxed text-slate-300">
                        BhuWaivs is a seismic monitoring system that brings sensing, on-device analysis, and live data together to help teams observe vibration and structural response in the field.
                    </p>
                </div>
            </section>

            <section className="border-b border-slate-200 bg-slate-50 px-6 py-16 sm:px-10 sm:py-20 lg:px-12">
                <div className="mx-auto max-w-7xl">
                    <p className="text-sm font-semibold uppercase tracking-widest text-blue-800">How it works</p>
                    <h2 className="mt-3 max-w-2xl font-serif text-3xl font-bold leading-tight text-slate-900 sm:text-4xl">
                        A complete view, from vibration to insight.
                    </h2>
                    <div className="mt-10 grid gap-5 md:grid-cols-3">
                        <article className="rounded-lg border border-slate-200 bg-white p-6">
                            <span className="text-sm font-semibold text-orange-600">01 / Sense</span>
                            <h3 className="mt-4 text-xl font-semibold text-slate-900">Capture ground motion</h3>
                            <p className="mt-3 leading-relaxed text-slate-600">
                                Tri-axial MEMS sensors measure vibration across three axes, creating a detailed picture of local motion.
                            </p>
                        </article>
                        <article className="rounded-lg border border-slate-200 bg-white p-6">
                            <span className="text-sm font-semibold text-orange-600">02 / Analyze</span>
                            <h3 className="mt-4 text-xl font-semibold text-slate-900">Classify at the edge</h3>
                            <p className="mt-3 leading-relaxed text-slate-600">
                                On-device processing helps identify relevant events before data is sent, keeping telemetry focused.
                            </p>
                        </article>
                        <article className="rounded-lg border border-slate-200 bg-white p-6">
                            <span className="text-sm font-semibold text-orange-600">03 / Observe</span>
                            <h3 className="mt-4 text-xl font-semibold text-slate-900">Review live readings</h3>
                            <p className="mt-3 leading-relaxed text-slate-600">
                                Connected dashboards bring sensor readings and device locations into one place for monitoring.
                            </p>
                        </article>
                    </div>
                </div>
            </section>

            <section className="bg-white px-6 py-16 sm:px-10 sm:py-20 lg:px-12">
                <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-16">
                    <div>
                        <p className="text-sm font-semibold uppercase tracking-widest text-blue-800">Research to field</p>
                        <h2 className="mt-3 font-serif text-3xl font-bold leading-tight text-slate-900 sm:text-4xl">
                            Built on seismic engineering experience.
                        </h2>
                    </div>
                    <div className="border-l-2 border-orange-500 pl-6 sm:pl-8">
                        <p className="text-lg leading-relaxed text-slate-600">
                           Shriseismic  was incubated at TIDE, IIT Roorkee. The BhuWaivs team brings research in MEMS-based structural health monitoring into a connected system designed for real-world observation.
                        </p>
                        <p className="mt-5 text-sm font-semibold text-slate-900">Shriseismic  · TIDE, IIT Roorkee</p>
                    </div>
                </div>
            </section>
            

            <section className="bg-[#17479b] px-6 py-14 text-white sm:px-10 lg:px-12">
                <div className="mx-auto flex max-w-7xl flex-col gap-6 md:flex-row md:items-center md:justify-between">
                    <div>
                        <h2 className="font-serif text-3xl font-bold leading-tight">Explore the monitoring dashboard.</h2>
                        <p className="mt-2 max-w-2xl leading-relaxed text-blue-100">
                            See live sensor data and available devices across the network.
                        </p>
                    </div>
                    <Link
                        to="/live-graph"
                        className="inline-flex min-h-12 shrink-0 items-center justify-center gap-4 rounded-lg bg-white px-6 py-3 font-semibold text-blue-900 no-underline transition-colors hover:bg-blue-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-blue-800"
                    >
                        Open Live Dashboard <span aria-hidden="true">→</span>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default About;
